// How the floor probe is doing, as counters — read by the speed meter so one
// line can answer both halves of "why does this feel slow here".
//
// A plain module object, like gaitBridge and talkBridge: it changes every frame
// and nothing should re-render because a raycast hit something.
//
// The two numbers together are what makes the readout decisive. Speed alone
// cannot tell you WHY it dropped, and a miss rate alone cannot tell you whether
// it cost anything. Seeing "2.40 u/s · probe 100%" while the world feels slow
// rules out the whole mechanism in one glance, which is the answer that stops
// people looking in the wrong place — including me, twice.
export const floorBridge = { hit: 0, miss: 0, reset() { this.hit = 0; this.miss = 0; } };
